module.exports = __webpack_public_path__ + "img/firma.eecbc1c2.svg";